import React from "react";
import Input from "./Input";
import validation from "./Validation";

class InputOut extends Input {

  render(){
    return(
      <Input
        {...this.props}
        type="text"
      />
    );
  }

}

const InputTexto = validation(InputOut);

export default InputTexto;